<template>
  <v-row align="stretch" no-gutters style="height: inherit;">
    <v-col cols="3" style="height: inherit;">
      <v-list-item active-class="boring" :to="parentRouteTo" class="px-3" :style="{ height: toolBarHeight + 'px' }">
        <v-list-item-icon class="my-auto mr-3">
          <v-icon color="primary">mdi-chevron-left</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Back to resources
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <slot name="menu"></slot>
    </v-col>
    <v-col cols="9" style="height: inherit; background-color: #e2e2e2;">
      <slot name="document"></slot>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: "GenericDocumentViewer",
  props: {
    toolBarHeight: { type: Number, default: 68 },
  },
  components: {},

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    parentRouteTo() {
      const chain = this.$route.matched;
      if (chain && chain.length >= 2) {
        const parent = chain[chain.length - 2];
        if (parent && parent.name) {
          const params = { ...this.$route.params };
          delete params.templateKey;
          return { name: parent.name, params, query: { ...this.$route.query } };
        }
        return { path: chain[chain.length - 2].path, query: { ...this.$route.query } };
      }
      return { name: "Home" };
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.boring:not(:hover)::before {
  background-color: transparent !important;
}
</style>